module.exports = __webpack_public_path__ + "arrow-right-blue-icon/arrow-right-blue-icon-6156e38c741e67a3c8001fb43570e032.svg";